
import React, { useEffect, useState } from "react";
import './poolDetails.css'
import INCSUBPoolInfoCard from "../../components/Pools/poolInfo";
import INCSUBpoolMemberDetailCard from "../../components/Pools/poolMemberDetailCard";
import { useDispatch, useSelector } from 'react-redux';
import { setPlatformPath, setPoolPath } from '../../redux/commonSlice';
import { toast } from "react-toastify";
import { setIsSuspendPopup, setPoolChat, setPoolDetails, setPoolList, setRefundData } from "../../features/pools/poolsSlice";
import { useNavigate } from "react-router";
import { getPoolChat, getRefundStatus, getSinglePool, updateSuspend } from "../../services/poolServices";
import INCSUBButton from "../../components/common/Button/INCSUBButton";
import INCSUBPoolChat from "../../components/Pools/PoolChat";
import INCSUBSuspendPermissionPopup from "./suspend/SuspendPermissionPopup";
import { setPlatformPathRoot } from "../../features/platforms/platformsSlice";
import { setComplaintRoute } from "../../features/complaints/complaintsSlice";

function INCSUBPoolDetails({ platform, plan, poolId }) {
    const platformPath = useSelector((state) => state.common.platformPath);
    const routeStatus = useSelector((state) => state.common.routeStatus);
    const poolDetails = useSelector((state) => state.pools.poolDetails)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pool = useSelector((state) => state.pools.selectedPool);
    const poolChat = useSelector((state) => state.pools.poolChat);
    const isSuspendPopup = useSelector((state) => state.pools.isSuspendPopup);
    const platformPathRoot = useSelector((state) => state.platforms.platformPathRoot);
    const [loader, setLoader] = useState(false);
    const poolList = useSelector((state) => state.pools.poolList)

    const fetchPoolDetails = async () => {
        setLoader(true)
        try {
            const poolData = await getSinglePool(pool.poolId);
            if (!poolData) {
                toast.error("Something Went Wrong")
            }
            if (poolData.status === 200) {
                dispatch(setPoolDetails(poolData.data.data))
            } else if (poolData.status === 401) {
                navigate('/login');
            } else if ([400].includes(poolData.status)) {
                toast.error(poolData.message);
            }
        } catch (error) {
            toast.warning('Something went Wrong');
        } finally {
            setLoader(false)
        }
    }
    useEffect(() => {
        if (pool) {
            fetchPoolDetails();
        }
    }, [pool]);


    const [isOpenChat, setIsopenChat] = useState(false);
    const handleViewChat = async (e) => {
        try {
            const chatData = await getPoolChat(poolDetails.groupChatId, poolDetails.hostId);
            if (chatData.status === 200) {
                dispatch(setPoolChat(chatData.data.data))
                setIsopenChat(true);
            } else if (chatData.status === 401) {
                window.localStorage.setItem('userData', '')
                navigate('/login')
            } else {
                toast.error("Something Went Wrong");
            }
        } catch (error) {
            toast.error("Something Went Wrong");
        }
    }

    const [suspendData, setSuspendData] = useState();

    const handleSuspendPermission = async (poolId, userId, type) => {
        setSuspendData({ poolId: poolId, userId: userId, type: type })
        try {
            const refundData = await getRefundStatus(poolId, userId);
            if (refundData.status === 200) {
                dispatch(setRefundData(refundData.data.data));
                dispatch(setIsSuspendPopup(true));
            } else if (refundData.status === 401) {
                navigate('/login');
                window.localStorage.setItem('userData', null);
            } else if (![200, 401].includes(refundData.status)) {
                toast.error(refundData.data.message)
            }
        } catch (error) {
            toast.error("Something Went Wrong");
        }
    }
    const handleSuspend = async (poolId, userId, isSuspended) => {
        try {
            const data = await updateSuspend(poolId, userId, isSuspended);
            if (data.status === 200) {
                const updatedList = poolList?.poolDetailList.map((pool) =>
                    pool.poolId === data.data.data.poolId ? {...pool,
                        currentMembers:data.data.data.poolMemberSize
                    } : pool
                );

                dispatch(setPoolList({
                    ...poolList,
                    poolDetailList: updatedList
                }));
                dispatch(setPoolDetails(data.data.data))
                dispatch(setIsSuspendPopup(false))
            } else if (data.status === 401) {
                navigate('/login');
                window.localStorage.setItem('userData', null);
            } else if (![200, 401].includes(data.status)) {
                toast.error(data.data.message);
            }
        } catch (error) {
            toast.error("Something Went Wrong");
        }
    }

    return (
        <div className="INCSUBPoolDetails_ctn">
            {
                pool ?

                    <div className="INCSUBPoolDetails_Search_filters">{
                        routeStatus === '/platforms' ?
                            <div className="INCSUBPoolDetails_path">
                                <div className='INCSUBPoolDetails_filter_section_path_btn'><svg onClick={() => {
                                    dispatch(setPlatformPathRoot(platformPathRoot.substring(0, platformPathRoot.lastIndexOf('/'))))
                                    dispatch(setPlatformPath('/platform/plan/pools'))
                                }
                                } className='back_arrow' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12 19L5 12L12 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                    <h1>{platformPathRoot}</h1>
                                </div>
                            </div> : <div className="INCSUBPoolDetails_path">
                                <div className='INCSUBPoolDetails_filter_section_path_btn'><svg onClick={() => {
                                    dispatch(setPoolPath('/pools'))
                                    if (routeStatus === '/complaints') {
                                        dispatch(setComplaintRoute('/complaints/complainDetails'));
                                    }
                                }} className='back_arrow' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12 19L5 12L12 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>{<p>{routeStatus === '/complaints' ? 'Complaints/ details/ ' : null}</p>}
                                    <h1>{poolDetails ? poolDetails.poolName : ''}</h1>
                                </div>

                            </div>}
                        <INCSUBButton text={'View Chat'} color={'#ffffff'} background='#4880FF' clickFun={handleViewChat} />
                    </div> : null}
            {!loader ? <>{poolDetails ?
                <INCSUBPoolInfoCard pool={poolDetails} fun={handleSuspendPermission} /> : null
            }

                {poolDetails ? <INCSUBpoolMemberDetailCard pool={poolDetails} fun={handleSuspendPermission} /> : null}</> : <div className="INCSUBPoolDetails_loader_container"></div>}
            {isOpenChat ? <INCSUBPoolChat poolChat={poolChat} poolName={poolDetails.poolName} poolHost={poolDetails.hostName} setIsOpenChat={setIsopenChat} poolImage={poolDetails.platformImage} /> : null}
            {
                isSuspendPopup ? <INCSUBSuspendPermissionPopup fun={handleSuspend} suspendData={suspendData} /> : null
            }
        </div>
    )

}

export default INCSUBPoolDetails;